module.exports = new __parcel__URL__("uncheckedCircle.b437806c.svg").toString();